import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgParentTicket = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.1668 17.0084L15.3418 15.8334L12.5001 12.9917L11.3251 14.1667L14.1668 17.0084ZM6.25011 6.66675H9.16678V11.3251L4.65845 15.8334L5.83345 17.0084L10.8334 12.0084V6.66675H13.7501L10.0001 2.91675L6.25011 6.66675Z",
		fill: "#424D57"
	})
});
export default SvgParentTicket;
